import * as React from 'react'
import { Box, MultiSelect } from '@mantine/core'
//@ts-ignore
import iso3311a2 from 'iso-country-lookup'
import { getFlagURL } from '../lib/helper'

interface Props {
	countryCodes: string[]
	onChange: (countryCodes: string[]) => void
	placeholder?: string
	initialValue?: string[]
}

export const Flag = ({ isoCode }: { isoCode: string }) => (
	<img
		alt={iso3311a2.getCountry(isoCode.toUpperCase())}
		src={getFlagURL(isoCode)}
		className="flag"
		height={14}
		style={{ marginTop: '-2px' }}
	/>
)

// Mantine 7: custom option rendering via renderOption combobox API
function renderCountryOption({
	option,
}: {
	option: { value: string; label: string }
}) {
	return (
		<Box>
			<span className="country-option">
				<Flag isoCode={String(option.value)} />
				<span>{String(option.label)}</span>
			</span>
		</Box>
	)
}

const CountryFilterInput = ({
	countryCodes,
	onChange,
	placeholder,
	initialValue,
}: Props) => {
	const [value, setValue] = React.useState<string[]>(initialValue ?? [])

	const possibleCountries = React.useMemo(
		() =>
			countryCodes
				.map((countryCode) => ({
					label: iso3311a2.getCountry(countryCode.toUpperCase()),
					value: countryCode,
				}))
				.sort((a, b) => a.label.localeCompare(b.label)),
		[countryCodes],
	)

	React.useEffect(() => {
		if (value !== initialValue) {
			if (!value) {
				onChange([])
			} else {
				onChange(value)
			}
		}
	}, [value])

	React.useEffect(() => {
		if (!!initialValue && initialValue.length > 0) {
			setValue(initialValue)
		}
	}, [initialValue])

	return (
		<div id="country-filter-input">
			<MultiSelect
				data={possibleCountries}
				renderOption={renderCountryOption}
				searchable={true}
				value={value}
				placeholder={placeholder ?? 'country...'}
				disabled={possibleCountries.length < 2}
				onChange={setValue}
				clearable={(value ?? []).length > 1}
				size="md"
			/>
		</div>
	)
}

export default CountryFilterInput
